module.exports = __webpack_public_path__ + "static/img/Dashu_Banner_summer.c2f11fec.jpg";